import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import { positionedWrapperStyle } from '../shared.styles';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useHistoryDropdownStyles = makeStyles(() => ({
  historyButton: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    height: 40,
    padding: '0 24px',
    borderRadius: radius.sm,
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    letterSpacing: '0.28px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: colors.hoverSurface,
    },
  },
  historyIcon: {
    width: 16,
    height: 16,
    color: colors.primaryDark,
  },
  historyDropdownIcon: {
    width: 16,
    height: 16,
    color: colors.primaryDark,
    transition: 'transform 0.2s ease',
  },
  historyDropdownIconOpen: {
    transform: 'rotate(180deg)',
  },
  historyPanel: {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    right: 0,
    minWidth: 'max-content',
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    zIndex: 10,
    listStyle: 'none',
    margin: 0,
    padding: `${spacing.xs}px 0`,
  },
  historyItem: {
    width: '100%',
    padding: '8px 16px',
    border: 0,
    backgroundColor: 'transparent',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    cursor: 'pointer',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: colors.hoverSurface,
    },
  },
  historyItemItalic: {
    fontStyle: 'italic',
  },
  historyItemActive: {
    fontFamily: fonts.opensansSemiBold,
    color: colors.primary,
  },
  historyWrapper: {
    ...positionedWrapperStyle,
  },
}));
